export const SERVICE_ACCOUNTS = {
  OPTION: 'Service account',
  MARK_TITLE: 'Mark as service account',
  MARK_DESCRIPTION: (name: string) =>
    `Mark ${name} as a service account? They leave the employee list and can't sign in. Their phishing results, policy signatures and assignments are deleted.`,
  MARK_CONFIRM: 'Mark as service account',
  MARKED: 'Marked as a service account',
  TWO_FACTOR: '2FA',
  STATUS: 'Status',
  MARKED_ON: 'Marked on',
  RESTORED: 'Moved back to the employees',
}
